<template>
  <div class="password-eye__container">
    <b-form-input
      class="password-eye__input"
      v-model="valueProxy"
      v-bind="extraBinds"
      v-on="$listeners"
      :type="inputType"
    ></b-form-input>
    <span
      v-if="!!(valueProxy || '').trim()"
      class="material-icons-round"
      @click="toggleVisibility"
    >
      {{ passwordVisible ? 'visibility_off' : 'visibility' }}
    </span>
    <b-form-invalid-feedback
    >
      {{ errorMessage }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import extraBindsMixin from '@/components/mixins/extraBindsMixin';

const inputType = {
  PASSWORD: 'password',
  TEXT: 'text',
};

export default {
  props: {
    value: {
      type: String,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },
  mixins: [
    extraBindsMixin,
  ],
  data: () => ({
    passwordVisible: false,
  }),
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inputType() {
      return this.passwordVisible ? inputType.TEXT : inputType.PASSWORD;
    },
  },
  methods: {
    toggleVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>

<style lang="sass" scoped>
.password-eye
  &__container
    position: relative

    & .material-icons-round
      position: absolute
      width: 1.8rem
      top: .7rem
      right: .5rem
      cursor: pointer
      color: var(--color-gray-intermediary)
      transition: color .2s ease-in-out

      &:hover
        color: var(--color-gray-medium-dark)

  &__input
    padding-right: 2.7rem
  &__input::-ms-reveal
    display: none

</style>
